<template>
  <b-row class="title-container">
    <b-col cols="12" md="2" sm="4" sx="4" v-if="goBack" class="title-go-back">
      <Button location="title" type="white" @click="handleGoBack()">
        Voltar
      </Button>
    </b-col>
    <b-col>
      <h1 class="title" :class="classes">
        {{ title }}
      </h1>
    </b-col>
    <b-col class="title-actions">
      <b-row>
        <b-col sm="3" class="hidden-print d-none d-sm-block" v-if="hasPrint">
          <Button
            class="btn-white"
            type="white"
            location="title"
            @click="print()"
          >
            <Printer title="Imprimir" /> Imprimir
          </Button>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" class="hidden-print mr-2" v-if="hasNewRegister">
          <Button
            id="newButton"
            type="success"
            location="title"
            :tooltipText="tooltipNewButton"
            :disabled="disableNewButton"
            :reasonsToDisableNewButton="reasonsToDisableNewButton"
            @click="routeNewRegister()"
          >
            {{ newRegisterButtonName }}
          </Button>
        </b-col>
      </b-row>
      <slot name="actions" />
    </b-col>
  </b-row>
</template>

<script>
import Printer from 'vue-material-design-icons/Printer';
import { Button } from '@/components/Form';

export default {
  components: {
    Button,
    Printer,
  },
  props: {
    tooltipNewButton: {
      type: String,
      required: false,
    },
    reasonsToDisableNewButton: {
      type: Array,
      required: false,
    },
    disableNewButton: {
      type: Boolean,
      required: false,
    },
    hasPrint: {
      type: Boolean,
      default: false,
    },
    hasNewRegister: {
      type: Boolean,
      default: false,
    },
    newRegisterButtonName: {
      type: String,
      default: 'Cadastrar',
    },
    title: {
      type: String,
      required: true,
    },
    titleAlign: {
      type: String,
      validator: () => ['left', 'right', 'center'],
      default: () => 'left',
    },
    margin: {
      type: String,
      validator: () => ['default', 'large'],
      default: () => 'large',
    },
    marginTop: {
      type: Boolean,
      default: () => false,
    },
    routeNewRegister: {
      type: Function,
      required: false,
    },
    goBack: {
      type: String,
      required: false,
      default: null,
    },
  },
  name: 'Title',
  methods: {
    print() {
      window.print();
    },
    handleGoBack() {
      this.$router.push(this.goBack);
    },
  },
  computed: {
    classes() {
      return {
        [`text-${this.titleAlign}`]: true,
        'title-center-go-back': !!this.goBack,
        'title-center-vertical': !!this.goBack || this.hasPrint || this.add,
        'title-margin-large': this.margin === 'large',
        'title-margin-top': this.marginTop,
      };
    },
  },
};
</script>
